// Avatar of Fire helpers. Pure. No React, no Three.js.
//
// ── Codex (Avatar of Fire) ──
//   "Tap → Play or draw a site.
//    Tap → This turn, fire sites in your hand are also Fireballs."
//
// ── Codex (Fireball) ──
//   "Shoot a projectile. It deals 4 damage on impact, and 2 damage to
//    each other unit at that location."
//
// The avatar's tap ability resolves a single fire-site-as-Fireball
// cast: the controller picks a Fire Site from hand, that site goes to
// their cemetery as a cast Magic spell, then Fireball's projectile
// effect resolves from the avatar's cell. One tap = one Fireball;
// matches Sorcery's "Avatars can only tap once per turn" so the
// rules-text "this turn" duration is mechanically a single use.
//
// Catalog shape is the NORMALIZED card object emitted by
// `normalizeSorceryCard` (elements is `[{id, name}]`, type is a
// top-level string).

function lookupCatalog(card, catalog) {
  if (!card || !catalog) return null;
  return catalog.find((c) => c?.unique_id === card.cardId) || null;
}

function hasFireElement(catalogCard) {
  const list = catalogCard?.elements || [];
  return list.some((e) => String(e?.id || e?.name || '').toLowerCase() === 'fire');
}

/** True iff `card` (a hand cardInstance) is a Fire Site in the catalog. */
export function isFireSite(card, catalog) {
  const full = lookupCatalog(card, catalog);
  if (!full) return false;
  if (full.type !== 'Site') return false;
  return hasFireElement(full);
}

/** Filter a hand card list down to Fire Sites. */
export function findFireSitesInHand(handCards, catalog) {
  return (handCards || []).filter((c) => isFireSite(c, catalog));
}
